<section class="section service-area bg-gray overflow-hidden ptb_100">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-12 col-lg-6 order-2 order-lg-1">
                <!-- Service Text -->
                <div class="service-text pt-4 pt-lg-0">
                    <h2 class="text-capitalize mb-4">Make your Device Manage Everything For you</h2>
                    <!-- Service List -->
                    <ul class="service-list">
                        <!-- Single Service -->
                        <li class="single-service media py-2">
                            <div class="service-icon pr-4">
                                <span><i class="fab fa-buffer"></i></span>
                            </div>
                            <div class="service-text media-body">
                                <p>Fully layered dolor sit amet, consectetur adipisicing elit. Facere, nobis, id expedita dolores officiis laboriosam.</p>
                            </div>
                        </li>
                        <!-- Single Service -->
                        <li class="single-service media py-2">
                            <div class="service-icon pr-4">
                                <span><i class="fas fa-brush"></i></span>
                            </div>
                            <div class="service-text media-body">
                                <p>Customizable design dolor sit amet, consectetur adipisicing elit. Facere, nobis, id expedita dolores officiis laboriosam.</p>
                            </div>
                        </li>
                        <!-- Single Service -->
                        <li class="single-service media py-2">
                            <div class="service-icon pr-4">
                                <span><i class="fas fa-burn"></i></span>
                            </div>
                            <div class="service-text media-body">
                                <p>Drop ipsum dolor sit amet, consectetur adipisicing elit. Facere, nobis, id expedita dolores officiis laboriosam.</p>
                            </div>
                        </li>
                        <!-- Single Service -->
                        <li class="single-service media py-2">
                            <div class="service-icon pr-4">
                                <span><i class="fas fa-cart-arrow-down"></i></span>
                            </div>
                            <div class="service-text media-body">
                                <p>Marketing chart dolor sit amet, consectetur adipisicing elit. Facere, nobis, id expedita dolores officiis laboriosam.</p>
                            </div>
                        </li>
                    </ul>
                    <a href="#" class="btn btn-bordered mt-4">Learn More</a>
                </div>
            </div>
            <div class="col-12 col-lg-4 order-1 order-lg-2 d-none d-lg-block">
                <!-- Service Thumb -->
                <div class="service-thumb mx-auto">
                    <img src="assets/img/features_thumb.png" alt="">
                </div>
            </div>
        </div>
    </div>
</section>